<div class="view intro jarallax"  [style]="Style()">
  <div style="opacity: 0.5; background-color: rgb(35, 35, 35);">
  </div>

  <div class="container">
    <ng-content id="content"></ng-content>
  </div>
</div>
